import React from "react";
import { Datagrid, FunctionField, TextField, useNotify, useRefresh } from "react-admin";
import { IconButton, Tooltip, Zoom } from "@material-ui/core";
import FlightTakeoffIcon from "@material-ui/icons/FlightTakeoff";
import { CustomDateField } from "../../../../../Components/CustomDateField";
import { EnumField } from "../../../../../Components/EnumField";
import RequirementCategoryToolTip from "./RequirementCategoryToolTip";
import RefNoField from "../../../../../Components/ReferenceFields/RefNoField/RefNoField";
import CopyableTableWrapper from "../../../../../Components/CopyableTableWrapper";
import { DetailButton } from "../../../../../Components/DetailButton";
import { PbhRequestStatus } from "../../../../../Enums/PbhRequestStatus";
import { useAppDataProvider } from "../../../../../dataprovider";
import ShipFromIstDialog from "./ShipFromIstDialog";

export const LocalRepairDataGrid = props => {
  const [shipCandidate, setShipCandidate] = React.useState<any>(null);
  const [shipping, setShipping] = React.useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleShipConfirm = () => {
    if (!shipCandidate) return;
    setShipping(true);
    const model = {
      ...shipCandidate,
      requestStatus: PbhRequestStatus.UnshippedSvc,
      isLocalRepair: false,
    };
    dataProvider
      .updatePbhRequestOrder(model)
      .then(() => {
        notify("Shipped from IST successfully. Request moved to Unshipped SVC.", "success");
        props?.reloadTabs?.();
        refresh();
      })
      .catch((error: any) => {
        notify(error?.message ?? "Failed to ship from IST.", "error");
      })
      .finally(() => {
        setShipping(false);
        setShipCandidate(null);
      });
  };

  return (
    <>
      <ShipFromIstDialog
        record={shipCandidate}
        loading={shipping}
        onClose={() => !shipping && setShipCandidate(null)}
        onConfirm={handleShipConfirm}
      />
      <CopyableTableWrapper>
        <Datagrid optimized {...props} classes={{ table: props.classes.datagrid }} hasBulkActions={false}>
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <div style={{ display: "flex", gap: 4, marginRight: "10px", alignItems: "center" }}>
                <DetailButton resource={"pbhrequestorders"} record={record} />
                <IconButton
                  style={{ width: 40, color: "#1565c0" }}
                  onClick={e => {
                    e.stopPropagation();
                    setShipCandidate(record);
                  }}
                >
                  <Tooltip TransitionComponent={Zoom} title="Ship from IST">
                    <FlightTakeoffIcon />
                  </Tooltip>
                </IconButton>
              </div>
            )}
          />
          <RefNoField label="REF NO" />
          <TextField source="customerName" label="CUSTOMER" sortable={false} />
          <TextField source="customerPo" label="CUSTOMER PO" />
          <FunctionField
            sortable={false}
            label="REQUIREMENT CATEGORY"
            render={(record: any) => <RequirementCategoryToolTip record={record} source="requirementCategoryText" />}
          />
          <EnumField label="Status" enumName="PbhRequestStatus" source="requestStatus" />
          <TextField source="pn" label="PN" />
          <TextField source="pnDescription" label="PN DESCRIPTION" />
          <TextField source="airportCode" label="DESTINATION" />
          <TextField source="acRegistration" label="AC" />
          <CustomDateField source="requestedDeliveryDate" label="REQUESTED DELIVERY DATE" showTime locales="en-GB" />
          <TextField source="currentPbhNote" label="PBH NOTE" />
          <TextField source="advancedXo" label="ADV XO" />
        </Datagrid>
      </CopyableTableWrapper>
    </>
  );
};

export default LocalRepairDataGrid;
